'use strict';

const angularModule = angular.module('t2g.common.data-access.soft-plus-sync', []);

module.exports = angularModule;

angularModule.factory(
  'SoftPlusSyncDA',
  ($http, settings, $q, LoadingIndicatorService, UserSession) => {
    /**
     * check if SoftPLUS user is syncing
     */
    const isSyncing = async () => {
      try {
        LoadingIndicatorService.show();
        const office = UserSession.getOffice();

        const { data } = await $http.get(settings.apiBase + `/api/v2/soft-plus/${office}`);

        LoadingIndicatorService.hide();
        return data;
      } catch (error) {
        LoadingIndicatorService.hide();
        return error;
      }
    };

    /**
     * save new SoftPLUS user for syncing
     * @param {*} softPlusCredentials
     */
    const sync = async ({ companyGln }) => {
      try {
        LoadingIndicatorService.show();
        const office = UserSession.getOffice();
        const request = { companyGln };

        const { data } = await $http.post(
          settings.apiBase + `/api/v2/soft-plus/${office}`,
          request,
        );

        LoadingIndicatorService.hide();
        return data;
      } catch (error) {
        LoadingIndicatorService.hide();
        return $q.reject(error);
      }
    };

    /**
     * remove SoftPLUS user from syncing
     */
    const removeSync = async () => {
      try {
        LoadingIndicatorService.show();
        const office = UserSession.getOffice();

        const { data } = await $http.delete(settings.apiBase + `/api/v2/soft-plus/${office}`);

        LoadingIndicatorService.hide();
        return data;
      } catch (error) {
        LoadingIndicatorService.hide();
        throw error;
      }
    };

    /**
     * sync SoftPLUS appointments
     */
    const syncSoftPLusAppointments = async () => {
      try {
        LoadingIndicatorService.show();
        const office = UserSession.getOffice();

        const { data } = await $http.get(
          settings.apiBase + `/api/v2/soft-plus/sync-from-soft-plus-single/${office}`,
        );

        LoadingIndicatorService.hide();
        return data;
      } catch (error) {
        LoadingIndicatorService.hide();
        throw error;
      }
    };

    return {
      sync,
      removeSync,
      isSyncing,
      syncSoftPLusAppointments,
    };
  },
);



// WEBPACK FOOTER //
// ./src/app/common/data-access/soft-plus-sync.js